'use client'
import { useEffect, useRef } from 'react';
import Image from 'next/image';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import styles from './Listing.module.css';
import Link from 'next/link';

// Register ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

export default function Listing() {
    const sectionRef = useRef(null);
    const listingsRef = useRef(null);

    useEffect(() => {
        const mm = gsap.matchMedia();

        mm.add("(min-width: 851px)", () => {
            const section = sectionRef.current;
            const listings = listingsRef.current;
            const viewport = section?.querySelector('.BottomListingContainer');

            if (!section || !listings || !viewport) return undefined;

            const distance = () => Math.max(0, listings.scrollWidth - viewport.clientWidth);
            const ctx = gsap.context(() => {
                gsap.fromTo(
                    listings,
                    { x: 0 },
                    {
                        x: () => -distance(),
                        ease: 'none',
                        scrollTrigger: {
                            trigger: section,
                            pin: true,
                            anticipatePin: 1,
                            start: 'top top',
                            end: () => `+=${Math.max(window.innerHeight, distance() * 1.2)}`,
                            scrub: 0.55,
                            invalidateOnRefresh: true,
                        },
                    },
                );
            }, section);

            return () => ctx.revert();
        });

        return () => mm.revert();
    }, []);

    return (
        <section ref={sectionRef} className={styles.section}>
            <div className={styles.topListingContainer}>
                <h1 className={styles.topTitle}>BEST-SELLERS</h1>
            </div>
            <div className={`BottomListingContainer ${styles.bottomListingContainer}`}>
                <div
                    ref={listingsRef}
                    className={`listings ${styles.listings}`}
                >
                    {/* Product 1 - MINCI */}
                    <div className={styles.productContainer}>
                        <div className={styles.containerUpper}>
                            <div className={styles.productImageContainer}>
                                <Image src={'https://longevity20155.sirv.com/minci/1.webp'} className={styles.productImage} alt="minci" width={400} height={400} priority unoptimized />
                                <Image src={'https://longevity20155.sirv.com/minci/2.webp'} className={styles.productImageHover} alt="minci hover" width={400} height={400} unoptimized />

                                <div className={styles.reviewsBadge}>
                                    <span className={styles.stars}>★★★★★</span>
                                    <span>4.8/5</span>
                                </div>

                                <div className={styles.priceBadge}>
                                    From 30dt /can
                                </div>
                            </div>
                        </div>
                        <div className={styles.containerLower}>
                            <div className={styles.lowerContent}>
                                <p className={styles.productName}>ZINC</p>
                                <Link href={'/product/minci'}><button className={`button button--pan ${styles.button}`}><span>SHOP NOW</span></button></Link>
                            </div>
                        </div>
                    </div>

                    {/* Product 2 - ZINC */}
                    <div className={styles.productContainer}>
                        <div className={styles.containerUpper}>
                            <div className={styles.productImageContainer}>
                                <Image src={'https://longevity20155.sirv.com/zinc/1.webp'} className={styles.productImage} alt="zinc" width={400} height={400} unoptimized />
                                <Image src={'https://longevity20155.sirv.com/zinc/2.webp'} className={styles.productImageHover} alt="zinc hover" width={400} height={400} unoptimized />

                                <div className={styles.reviewsBadge}>
                                    <span className={styles.stars}>★★★★★</span>
                                    <span>4.9/5</span>
                                </div>

                                <div className={styles.priceBadge}>
                                    From 30dt /can
                                </div>
                            </div>
                        </div>
                        <div className={styles.containerLower}>
                            <div className={styles.lowerContent}>
                                <p className={styles.productName}>ZINC</p>
                                <Link href={"/product/zinc"}><button className={`button button--pan ${styles.button}`}><span>SHOP NOW</span></button></Link>
                            </div>
                        </div>
                    </div>

                    <div className={styles.productContainer}>
                        <div className={styles.containerUpper}>
                            <div className={styles.productImageContainer}>
                                <Image src={'https://longevity20155.sirv.com/testo/1.webp'} className={styles.productImage} alt="testo" width={400} height={400} unoptimized />
                                <Image src={'https://longevity20155.sirv.com/testo/2.webp'} className={styles.productImageHover} alt="testo hover" width={400} height={400} unoptimized />
                                <div className={styles.reviewsBadge}>
                                    <span className={styles.stars}>★★★★☆</span>
                                    <span>4.6/5</span>
                                </div>
                                <div className={styles.priceBadge}>From 30dt /can</div>
                            </div>
                        </div>
                        <div className={styles.containerLower}>
                            <div className={styles.lowerContent}>
                                <p className={styles.productName}>TESTO</p>
                                <Link href={'/product/testo'}><button className={`button button--pan ${styles.button}`}><span>SHOP NOW</span></button></Link>
                            </div>
                        </div>
                    </div>

                    {/* Product 4 - EXTRA */}
                    <div className={styles.productContainer}>
                        <div className={styles.containerUpper}>
                            <div className={styles.productImageContainer}>
                                <Image src={'https://longevity20155.sirv.com/minci/1.webp'} className={styles.productImage} alt="extra" width={400} height={400} unoptimized />
                                <Image src={'https://longevity20155.sirv.com/minci/2.webp'} className={styles.productImageHover} alt="extra hover" width={400} height={400} unoptimized />
                                <div className={styles.reviewsBadge}>
                                    <span className={styles.stars}>★★★★★</span>
                                    <span>4.7/5</span>
                                </div>
                                <div className={styles.priceBadge}>From 30dt /can</div>
                            </div>
                        </div>
                        <div className={styles.containerLower}>
                            <div className={styles.lowerContent}>
                                <p className={styles.productName}>EXTRA</p>
                                <Link href={'/product/minci'}><button className={`button button--pan ${styles.button}`}><span>SHOP NOW</span></button></Link>
                            </div>
                        </div>
                    </div>

                    {/* Product 5 - PREMIUM */}
                    <div className={styles.productContainer}>
                        <div className={styles.containerUpper}>
                            <div className={styles.productImageContainer}>
                                <Image src={'https://longevity20155.sirv.com/zinc/1.webp'} className={styles.productImage} alt="premium" width={400} height={400} unoptimized />
                                <Image src={'https://longevity20155.sirv.com/zinc/2.webp'} className={styles.productImageHover} alt="premium hover" width={400} height={400} unoptimized />
                                <div className={styles.reviewsBadge}>
                                    <span className={styles.stars}>★★★★★</span>
                                    <span>5.0/5</span>
                                </div>
                                <div className={styles.priceBadge}>From 30dt /can</div>
                            </div>
                        </div>
                        <div className={styles.containerLower}>
                            <div className={styles.lowerContent}>
                                <p className={styles.productName}>PREMIUM</p>
                                <Link href={'/product/zinc'}><button className={`button button--pan ${styles.button}`}><span>SHOP NOW</span></button></Link>
                            </div>
                        </div>
                    </div>


                </div>
            </div>

        </section>
    )
}
